<template>
  <BaseFieldWrapper
    v-bind="{...$props, ...$attrs}"
    v-on="$listeners"

    v-slot="{vuelidateIns, value, listeners, attrs}"
  >
    <span>
      <input v-if="mounted" v-model="cypressTestInput" :id="attrs.id" style="display: none">
    
      <!-- v-bind="attrs"
        v-on="listeners" -->
      <editor
        :value="value"
        @input="listeners.input"
        :class="vuelidateIns && 'border-danger'"
  
        api-key="c21xora5cqvlh2qa9snoh4syuep4gwac8piuek5ozs52u839"
        :init="{
          height,
          toolbar:
            'undo redo | formatselect | bold italic backcolor | \
            alignleft aligncenter alignright alignjustify | \
            bullist numlist outdent indent | removeformat | help'
        }"
      />
    </span>
  </BaseFieldWrapper>
</template>

<script>

import Editor from "@tinymce/tinymce-vue"
import BaseFieldWrapper, { props } from "./FormFieldWrapper.vue"

export default {
  components: {
    'editor': Editor,
    BaseFieldWrapper,
  },
  props: {
    ...props,
    
    height: {
      type: Number,
      default: 300,
    },
    value: {
      type: String,
      default: "",
      required: false,
    },
  },
  data() {
    return {
      text: this.value,
      cypressTestInput: "",
      mounted: false,
    }
  },
  mounted() {
    this.mounted = true
  },
  watch: {
    value(val) {
      this.text = val
    },
    text(val) {
      this.$emit("input", val)
      this.cypressTestInput = val
    },
    cypressTestInput(val) {
      this.text = val
    },
  },
}

</script>

<style>

.tox .tox-toolbar--scrolling {
  flex-wrap: wrap !important;
}

</style>
